/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlCustomCase } from './ControlCustomCase';
import {
    ControlCustomCaseFromJSON,
    ControlCustomCaseFromJSONTyped,
    ControlCustomCaseToJSON,
} from './ControlCustomCase';

/**
 * 
 * @export
 * @interface ControlCustomCases
 */
export interface ControlCustomCases {
    /**
     * 
     * @type {Array<ControlCustomCase>}
     * @memberof ControlCustomCases
     */
    data: Array<ControlCustomCase>;
}

/**
 * Check if a given object implements the ControlCustomCases interface.
 */
export function instanceOfControlCustomCases(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function ControlCustomCasesFromJSON(json: any): ControlCustomCases {
    return ControlCustomCasesFromJSONTyped(json, false);
}

export function ControlCustomCasesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCustomCases {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ControlCustomCaseFromJSON)),
    };
}

export function ControlCustomCasesToJSON(value?: ControlCustomCases | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(ControlCustomCaseToJSON)),
    };
}

